<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Apply List to Jobs'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (!loaded) {
      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <ion-skeleton-text animated style="width: 40px; height: 16px;" />
        <ion-skeleton-text animated style="width: 120px; height: 16px; margin-left: 8px;" />
        <ion-skeleton-text animated style="width: 140px; height: 16px; margin-left: 8px;" />
      </tidy-row>
      @for (i of [1,2,3,4,5]; track i) {
        <tidy-card class="extra-bottom-padding">
          <tidy-row [alignLastItemRight]="true">
            <tidy-row class="vertical-align-center">
              <ion-skeleton-text animated style="width: 20px; height: 20px; border-radius: 4px; margin-right: 8px;" />
              <ion-skeleton-text animated style="width: 150px; height: 16px;" />
            </tidy-row>
            <div>
              <ion-skeleton-text animated style="width: 100px; height: 16px; margin-bottom: 4px;" />
              <ion-skeleton-text animated style="width: 60px; height: 14px;" />
            </div>
          </tidy-row>
        </tidy-card>
      }
      <tidy-card class="extra-bottom-padding">
        <tidy-row>
          <ion-skeleton-text animated style="width: 20px; height: 20px; border-radius: 4px; margin-right: 8px;" />
          <ion-skeleton-text animated style="width: 200px; height: 16px;" />
        </tidy-row>
      </tidy-card>
      <tidy-row>
        <ion-skeleton-text animated style="width: 100%; height: 44px; border-radius: 6px;" />
      </tidy-row>
    }

    @if (loaded) {
      @if (jobs?.length > 0) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Use'" /><span>&nbsp;</span>
            <tidy-text
              [body]="listName" /><span>&nbsp;</span>
            <tidy-text
              [body]="'Checklist for:'" />
        </tidy-row>
        @for (job of jobs; track job; let i = $index) {
          @if (showJob(i)) {
            <tidy-card>
              <tidy-row [alignLastItemRight]="true">
                <div>
                  <tidy-checkbox
                    [items]="[{viewValue: job?.template_data?.job?.service_type_details?.name, value: '' }]"
                    [initValue]="job?.usesThisList"
                    (checkedChange)="selectJob(job?.template_data?.job?.id)" />
                  <tidy-text
                    [helper]="job?.addressName"
                    style="margin-left: 26px" />
                </div>
                <div>
                  <tidy-text
                    [body]="(job?.template_data?.job?.start_datetime_local | parseDateTime: 'ddd') + ' ' + (job?.template_data?.job?.start_datetime_local | parseDateTime: 'MMM d')" /><br>
                  <tidy-text
                    [body]="job?.template_data?.job?.start_datetime_local | parseDateTime: 'h:mma'" />
                </div>
              </tidy-row>
            </tidy-card>
          }
        }
        @if (numberJobsToShow === 5 && jobs?.length > 5) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'Show More Jobs'"
              (action)="showMoreJobs()"
              class="link" />
          </tidy-row>
        }
        @if (hasTwoOrMoreLists) {
          <tidy-card>
            <tidy-row>
              <tidy-checkbox
                [items]="[{viewValue: 'Use as default list for future jobs', value: '' }]"
                [initValue]="listIsDefault"
                (checkedChange)="changeDefault()" />
            </tidy-row>
          </tidy-card>
        }
        @if (jobs?.length > 0) {
          <tidy-button
            [text]="'Save Changes'"
            [action]="boundSaveChanges"
            class="primary" />
        }
      }
      @if (!jobs || jobs.length === 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text [body]="'No jobs found'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'There are no scheduled jobs in the next 2 weeks.'" />
          </tidy-row>
        </tidy-alert>
      }
    }
  </tidy-wrapper>
</ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }
